import {
  ITypeFieldFilterOptions,
  OperatorType,
} from '~/client/graph/types.generated'

/**
 * The values of one static filter entry, or [] when there is none.
 *
 * Static means no fieldId: a fieldId marks a filter keyed on another field's selections,
 * which restricts conditionally and must never be read as a plain list. `operator` defaults
 * to In - the allow-list - and takes NotIn to read the matching deny-list.
 */
export function getAllowedFilterValues(
  filterOptions: ITypeFieldFilterOptions[] | null | undefined,
  propertyPath: string,
  operator: OperatorType = OperatorType.In,
): string[] {
  return (
    filterOptions?.find(
      f =>
        f.propertyPath === propertyPath &&
        f.operator === operator &&
        !f.fieldId,
    )?.values || []
  )
}
